import { createMetricsFactory } from 'metrics-js';
import { readUnhandledEnumCase } from 'rpc-client-utils';
import ApiNameToUpgradeProductMap from 'self-service-api/constants/ApiNameToUpgradeProductMap';
export const UIAUMetrics = createMetricsFactory('ui-addon-upgrades', {
  library: 'ui-addon-upgrades'
});
export const PurchaseMotionsComponentsMetrics = createMetricsFactory('purchase-motions-components', {
  library: 'purchase-motions-components'
});
export const trackTrialActivation = ({
  apiName,
  app
}) => {
  // matches existing UIAU tracker, https://git.hubteam.com/HubSpot/ui-addon-upgrades/blob/a768d23781caa55713e3862dfcf8eae6193f105f/ui-addon-upgrades/static/js/_core/utils/metricUtils.ts#L40-L45
  UIAUMetrics.counter('trial-activation', {
    app,
    upgradeProduct: ApiNameToUpgradeProductMap[apiName],
    repo: 'purchase-motions-components'
  }).increment();
  PurchaseMotionsComponentsMetrics.counter('trial-activation', {
    app,
    apiName
  }).increment();
};
export const trackPurchaseMotionFailure = ({
  uniqueId,
  apiName,
  purchaseMotion
}) => {
  UIAUMetrics.counter('purchase-motion-failure', {
    uniqueId,
    apiName,
    purchaseMotion: readUnhandledEnumCase(purchaseMotion),
    repo: 'purchase-motions-components'
  }).increment();
  PurchaseMotionsComponentsMetrics.counter('purchase-motion-failure', {
    uniqueId,
    apiName,
    purchaseMotion: readUnhandledEnumCase(purchaseMotion)
  }).increment();
};
export const incrementPurchaseOrderGenerationSuccess = apiNames => {
  UIAUMetrics.counter('purchase-order-generation-success', {
    type: 'buy-touchless',
    apiNames: JSON.stringify(apiNames),
    repo: 'purchase-motions-components'
  }).increment();
};
export const incrementPurchaseOrderGenerationFailure = apiNames => {
  UIAUMetrics.counter('purchase-order-generation-failure', {
    type: 'buy-touchless',
    apiNames: JSON.stringify(apiNames),
    repo: 'purchase-motions-components'
  }).increment();
};
export const trackPqlFailure = app => {
  UIAUMetrics.counter('pql-failure', {
    app,
    repo: 'purchase-motions-components'
  }).increment();
  PurchaseMotionsComponentsMetrics.counter('pql-failure', {
    app
  }).increment();
};
export const trackRequestSeatClick = ({
  apiName,
  isEmbeddedInBanner
}) => {
  UIAUMetrics.counter('request-seat-click', {
    apiName,
    isEmbeddedInBanner: isEmbeddedInBanner ? 'true' : 'false',
    repo: 'purchase-motions-components'
  }).increment();
  PurchaseMotionsComponentsMetrics.counter('request-seat-click', {
    apiName,
    isEmbeddedInBanner: isEmbeddedInBanner ? 'true' : 'false'
  }).increment();
};
export const trackRequestSeatSuccess = ({
  apiName,
  isEmbeddedInBanner
}) => {
  UIAUMetrics.counter('request-seat-success', {
    apiName,
    isEmbeddedInBanner: isEmbeddedInBanner ? 'true' : 'false',
    repo: 'purchase-motions-components'
  }).increment();
  PurchaseMotionsComponentsMetrics.counter('request-seat-success', {
    apiName,
    isEmbeddedInBanner: isEmbeddedInBanner ? 'true' : 'false'
  }).increment();
};
export const trackRequestSeatFailure = ({
  apiName,
  isEmbeddedInBanner
}) => {
  UIAUMetrics.counter('request-seat-failure', {
    apiName,
    isEmbeddedInBanner: isEmbeddedInBanner ? 'true' : 'false',
    repo: 'purchase-motions-components'
  }).increment();
  PurchaseMotionsComponentsMetrics.counter('request-seat-failure', {
    apiName,
    isEmbeddedInBanner: isEmbeddedInBanner ? 'true' : 'false'
  }).increment();
};